module.exports = __webpack_public_path__ + "d6e69bde225aaf5e7bc1dfe29710961c.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/tone.png
// module id = 80
// module chunks = 0